import { render, staticRenderFns } from "./SelectorTypeTable.vue?vue&type=template&id=581ac3d2&"
import script from "./SelectorTypeTable.vue?vue&type=script&lang=js&"
export * from "./SelectorTypeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports